import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import useBlog from 'common/hooks/useBlog'
import { ArticleContent } from '../articles/ArticleContent'
import { RecommendedBlogsSection } from './RecommendedBlogsSection'

const pageSize = 6

const Blog = () => {
  const { slug } = useParams()
  const {
    blog,
    getBlog,
    blogLoading,
    recommendedBlogs,
    getRecommendedBlogs,
    recommendedBlogsLoading,
  } = useBlog({ slug })

  useEffect(() => {
    getBlog()
    getRecommendedBlogs()
  }, [getBlog, getRecommendedBlogs])

  const [isExtended, setIsExtended] = useState<boolean>(false)
  const extendButtonRef = useRef(null)

  const extendClick = () => {
    setIsExtended(!isExtended)
  }

  useEffect(() => {
    if (!isExtended && extendButtonRef.current) {
      window.scrollTo({
        top: extendButtonRef.current.offsetTop - 50,
        behavior: 'smooth',
      })
    }
  }, [isExtended])

  return (
    <>
      {blogLoading ? (
        <>Loading...</>
      ) : (
        <div
          className='flex flex-col 
            px-[22px] sm:px-[40px] md:px-[80px] xl:px-[40px] 2xl:px-[110px] 
            py-[60px] sm:py-[70px] md:py-[80px] xl:py-[90px] 2xl:py-[110px] 
            gap-[60px]'
        >
          <ArticleContent
            item={blog}
            isExtended={isExtended}
            extendClick={extendClick}
            extendButtonRef={extendButtonRef}
          />
          {recommendedBlogsLoading ? (
            'Loading...'
          ) : (
            <RecommendedBlogsSection
              nr={pageSize}
              recommendedBlogs={recommendedBlogs}
            />
          )}
        </div>
      )}
    </>
  )
}

export default Blog
